(ns frontend.ui.page.lp-report-editor.step-5-approved.sub
  (:require
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]))

(def report-tab-path (conj editor-sub/editor-path :approved-report-tab))